import { schema } from 'normalizr'

export const organisationSchema = new schema.Entity(
  'organisations',
  {},
  {
    idAttribute: 'uuid'
  }
)

export const groupSchema = new schema.Entity(
  'groups',
  {},
  {
    idAttribute: 'uuid'
  }
)

export const groupReportSchema = new schema.Entity(
  'groups',
  {},
  {
    idAttribute: 'groupUuid'
  }
)

export const groupTrapSchema = new schema.Entity(
  'traps',
  {},
  {
    idAttribute: 'historyUuid'
  }
)

export const userTrapSchema = new schema.Entity(
  'traps',
  {},
  {
    idAttribute: 'uuid'
  }
)

export const peopleSchema = new schema.Entity(
  'people',
  {},
  {
    idAttribute: 'id'
  }
)

export const requestSchema = new schema.Entity(
  'requests',
  {},
  {
    idAttribute: 'uuid'
  }
)

export default groupSchema



// WEBPACK FOOTER //
// ./src/modules/schema.js